const state = {
    favoriteChannels: []
};

const actions = {
    getFavoriteChannels({commit, dispatch}) {
            let favoriteChannels = [];
            try {
                favoriteChannels = JSON.parse(localStorage.getItem('kartinatvWebplayer_favoriteChannels')) || [];
            }
            catch (e) {
                console.warn(e);
            }

            if (favoriteChannels && favoriteChannels.length > 0) {
                commit('GET_FAVORITE_CHANNELS_OK', favoriteChannels);
            }

            dispatch('markChannelsAsFavorites', favoriteChannels);
    },
    addToFavorites({commit, dispatch}, channel) {
        commit('ADD_TO_FAVORITE_CHANNELS', channel);

        dispatch('getFavoriteChannels');
    },
    removeFromFavorites({commit, dispatch}, channel) {
        commit('REMOVE_FROM_FAVORITE_CHANNELS', channel);

        dispatch('getFavoriteChannels');
    }
};

const mutations = {
    GET_FAVORITE_CHANNELS_OK(state, favoriteChannels) {
        state.favoriteChannels = favoriteChannels;
    },

    ADD_TO_FAVORITE_CHANNELS(state, channel) {
        state.favoriteChannels.push(channel.id);

        try {
            localStorage.setItem('kartinatvWebplayer_favoriteChannels', JSON.stringify(state.favoriteChannels));
        }
        catch (e) {
            console.warn(e);
        }

        channel.is_favorite = true;
    },

    REMOVE_FROM_FAVORITE_CHANNELS(state, channel) {
        state.favoriteChannels.splice(state.favoriteChannels.indexOf(channel.id), 1);

        try {
            localStorage.setItem('kartinatvWebplayer_favoriteChannels', JSON.stringify(state.favoriteChannels));
        }
        catch (e) {
            console.warn(e);
        }

        channel.is_favorite = false;
    },
};

export default {
    state,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/favorite-channels.js